export default __webpack_public_path__ + "static/media/analyticsIQ.66f1d004.png";